module.exports = __webpack_public_path__ + "static/be_cup_hero-3ccb57371e6b36d5f78110917c8ef4f7.jpg";